import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import { privateRoutes, routes } from "./pages/index";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import Unauthorized from "pages/SideTabPages/UnauthorizedAccess/Index";
import { SUBADMIN_ONBOARD, UNAUTHORIZED_ACCESS } from "config/paths";
import ProtectedRoute from "components/ProtectedRoute";
import { useMemo } from "react";
import { useUserPermissions } from "hooks/usePermissions";
import moduleConfig from "config/modules";
import OnboardLayout from "layout/OnboardLayout/OnBoardLayout";
import SubAdminOnboard from "pages/SideTabPages/Onboard/SubAdminOnboard";
// import useGetFcmToken from "hooks/useGetFcmToken";

function App() {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const { hasPermission } = useUserPermissions();

  const navigateTo = useMemo(() => {
    const findFirstAllowed = (module) => {
      if (module?.childLinks?.length) {
        for (let child of module.childLinks) {
          const allowed = findFirstAllowed(child);
          if (allowed) return allowed;
        }
      }

      if (
        module?.permission &&
        hasPermission(module.permission.module, module.permission.action)
      ) {
        return module.path || null;
      }

      return null;
    };

    for (let mod of moduleConfig) {
      const allowed = findFirstAllowed(mod);
      if (allowed) return allowed;
    }

    return null;
  }, [moduleConfig, hasPermission]);

  return (
    <>
      <Routes>
        {/* Public Routes */}
        {!isAuthenticated ? (
          <Route element={<AuthLayout />}>
            <Route index element={<Navigate to="/login" />} />
            {routes.map((data, index) => (
              <Route
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
            ))}
            <Route path="*" element={<Navigate to="/login" />} />
          </Route>
        ) : (
          <Route element={<Navigate to={navigateTo} />} />
        )}

        {
          isAuthenticated && (
            <Route element={<OnboardLayout />}>
              <Route path={SUBADMIN_ONBOARD} element={<SubAdminOnboard />} />
            </Route>
          )
        }

        {/* Private Routes */}
        {isAuthenticated ? (
          <Route element={<MainLayout />}>
            <Route index element={<Navigate to={navigateTo} />} />
            {privateRoutes.map((data, index) => (
              <Route
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={
                  <ProtectedRoute module={data.module} action={data.action}>
                    {data.component}
                  </ProtectedRoute>
                }
                key={index}
              />
            ))}
            <Route path={UNAUTHORIZED_ACCESS} element={<Unauthorized />} />
            <Route path="*" element={<Navigate to={navigateTo} />} />
          </Route>
        ) : (
          <Route element={<Navigate to="/login" />} />
        )}
      </Routes>
      <ToastContainer
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

export default App;
